import React, { useState } from 'react';
import '../styles/Header.css';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="header-nav">
      <div className="container header-container">
        <a href="/" className="logo">
          H
          <svg className="logo-aperture" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5"/>
            <path d="M12 2 L16 7 L12 22 L8 17 L12 2Z" fill="currentColor" opacity="0.3"/>
            <path d="M2 12 L7 8 L22 12 L17 16 L2 12Z" fill="currentColor" opacity="0.3"/>
            <path d="M12 22 L8 17 L12 2 L16 7 L12 22Z" fill="currentColor" opacity="0.2"/>
          </svg>
          RAZEL
        </a>
        
        {/* Mobile Menu Button */}
        <button 
          onClick={() => setIsOpen(!isOpen)} 
          className={`menu-btn ${isOpen ? 'open' : ''}`}
          aria-label="Toggle menu"
        >
          <span className="menu-icon-line"></span>
          <span className="menu-icon-line"></span>
          <span className="menu-icon-line"></span>
        </button>

        {/* Backdrop */}
        {isOpen && (
          <div 
            className="menu-backdrop" 
            onClick={() => setIsOpen(false)}
          ></div>
        )}

        {/* Menu Overlay */}
        <div className={`mobile-menu ${isOpen ? 'open' : ''}`}>
            <ul>
                <li><a href="#home" onClick={() => setIsOpen(false)}>Home</a></li>
                <li><a href="#insights" onClick={() => setIsOpen(false)}>Insights</a></li>
                <li><a href="#services" onClick={() => setIsOpen(false)}>Services</a></li>
                <li><a href="#portfolio" onClick={() => setIsOpen(false)}>Portfolio</a></li>
                <li><a href="#contact" onClick={() => setIsOpen(false)}>Contact</a></li>
            </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header;
